import charts from '../charts.js';
import graphs, * as graphOptions from '../charts/technicals/graphs.js';
import panels from '../charts/technicals/panels.js';
import moment from 'moment';
import ChartPage from '../includes/chart-page.js';

let chartPage;
let ichimokuVisible = false;
let sectionName;

const currentSettings = {};

function toggleGraph(value, active, colour = false) {
	chartPage.chart.toggleOverlay(value, active, colour);

	if (value === 'Ichimoku') {
		ichimokuVisible = active;
		chartPage.zoomChart();
	}

	chartPage.setNumWeeks();
}

window.changeGraphcolor = (value, color) => {
	toggleGraph(value, false);
	toggleGraph(value, true, color);
}

function addColorPickerEvent() {
	$("g[aria-label*='EMA'], g[aria-label*='SMA']").on("click", function() {
		const c = $(this).attr('aria-label');
		// console.log(c)
		$("#color-picker").data('name', c);
		$("#color-picker .color-line-name").html(c);
		$("#color-picker").show();
	}).css('cursor', 'pointer');
}

function togglePanel(value, active) {
	chartPage.chart.toggleIndicator(value, active);
}

function updateChart(noDraw = false) {
	if (!chartPage.form) {
		return false;
	}

	const series = chartPage.form.get('series-type');
	const period = chartPage.form.get('period-grouping');
	const overlays = chartPage.form.get('deviation-overlay');
	const indicators = chartPage.form.get('deviation-indicator');

	let hasChanges = false;

	if (sectionName === 'stock-score' && !indicators.includes('score')) {
		indicators.push('score');
	}

	if (!_.isEqual(series, currentSettings.series)) {
		toggleGraph(currentSettings.series, false);
		toggleGraph(series, true);

		currentSettings.series = series;
		hasChanges = true;
	}

	if (!_.isEqual(overlays, currentSettings.overlays)) {
		for (const item of overlays) {
			if (!currentSettings.overlays.includes(item)) {
				toggleGraph(item, true);
			}
		}

		for (const item of currentSettings.overlays) {
			if (!overlays.includes(item)) {
				toggleGraph(item, false);
			}
		}

		currentSettings.overlays = [ ... overlays ];
		hasChanges = true;
	}

	if (!_.isEqual(indicators, currentSettings.indicators)) {
		for (const item of indicators) {
			if (!currentSettings.indicators.includes(item)) {
				togglePanel(item, true);
			}
		}

		for (const item of currentSettings.indicators) {
			if (!indicators.includes(item)) {
				togglePanel(item, false);
			}
		}

		currentSettings.indicators = [ ... indicators ];
		hasChanges = true;
	}

	if (!_.isEqual(period, currentSettings.periodGrouping)) {
		// FIXME: figure this out
		chartPage.chart.xAxis.set('groupIntervals', charts.groupings[ period ]);
		// chartPage.chart.xAxis._groupData();

		if (!noDraw) {
			chartPage.zoomChart();
		}

		if (period === 'yearly' && chartPage.numHistoricalDataYears > 1) {
			const targetWeeks = Math.min(10 * 52, chartPage.numHistoricalDataYears * 52);

			if (chartPage.numWeeks < targetWeeks) {
				chartPage.setNumWeeks(targetWeeks);
			}
		}
	}

	return hasChanges;
}

function timeout(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

export default async function technicalsSection(res, section, data, chartName, chartSettings) {
	chartPage = new ChartPage();
	sectionName = chartName;

	const chartDefaults = _.pick(
		res,
		[ 'periodGrouping', 'defaultOverlays', 'defaultIndicators', 'defaultSeries' ]
	);

	if (res.savedFilters && res.lastSavedSettings && _.isObject(res.lastSavedSettings)) {
		if (res.lastSavedSettings.hasOwnProperty('series-type')) {
			chartDefaults.defaultSeries = res.lastSavedSettings['series-type'];
		}

		if (res.lastSavedSettings.hasOwnProperty('deviation-overlay')) {
			chartDefaults.defaultOverlays = [ ... res.lastSavedSettings['deviation-overlay'] ];
		}

		if (res.lastSavedSettings.hasOwnProperty('deviation-indicator')) {
			chartDefaults.defaultIndicators = [ ... res.lastSavedSettings['deviation-indicator'] ];
		}

		if (res.lastSavedSettings.hasOwnProperty('period-grouping')) {
			chartDefaults.periodGrouping = res.lastSavedSettings['period-grouping'];
		}
	}

	currentSettings.periodGrouping = chartDefaults.periodGrouping;
	currentSettings.series = chartDefaults.defaultSeries;
	currentSettings.overlays = [ ... chartDefaults.defaultOverlays ];
	currentSettings.indicators = [ ... chartDefaults.defaultIndicators ];

	await chartPage.init({
		res,
		section,
		data,
		sectionName,
		hasRemainingData: 'TOGGLE',
		chartSettings,
		chartDefaults,
		timePeriod: 'weeks',
		sliderDefault: res.numWeeks, // Math.min(res.numWeeks, 26),
		callbacks: {
			buildEmbed: () => {
				return {
					defaultOverlays: chartPage.form.get('deviation-overlay'),
					defaultIndicators: chartPage.form.get('deviation-indicator'),
					periodGrouping: chartPage.form.get('period-grouping'),
					defaultSeries: chartPage.form.get('series-type'),
					height: chartPage.chart.chart.height(),
				};
			},

			fetchRemianingData: () => {
				setTimeout(addColorPickerEvent,500);
			},

			setNumWeeks: () => {
				addColorPickerEvent();
			},

			getEndDate: () => {
				return ichimokuVisible ? res.chartData.slice(-1)[0].date : res.lastData.date;
			},

			drawChart: () => {
				updateChart();
			}
		},
	});

	// section.on('change', "input[name='scores_year_start']", function(e, value, noDraw = false) {
	// 	$(".return_label").each(function(){
	// 		const years = $(this).data('values')
	// 		const hold = $(this).data('hold')
	// 		$(this).find('.return_year').html(value)
	// 		$(this).find('.return_since_year').html(numberWithCommas(years[value]))
	// 		$(this).find('.hold_since_year').html(numberWithCommas(hold[value]))
	// 	})
	// });

	if (chartPage.form) {
		chartPage.form.setGlobalCallback('set', noDraw => {
			const hasChanges = updateChart(noDraw);

			if (hasChanges && !noDraw) {
				chartPage.drawChart();
			}
		});
	}

	$("#color-picker").on("click", ".color-choice", function() {
		//console.log($(this).parent().parent().data('name'), $(this).data('color'))
		changeGraphcolor($(this).parent().parent().data('name'), $(this).data('color'))
		$("#color-picker").hide();
	});
}
